import axios from 'axios';
import numbro from 'numbro';

export const formatAxisNumber = number => numbro(number).format('0[.]0a');

export const getChartData = url =>
  new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
